import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class DentalService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getMachines()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-scan-machine',{headers:webheader})
  }

  getTimeslots(lead_id, appointment_date, scan_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-time-slots/'+lead_id+'/'+appointment_date+'/'+scan_id,{headers:webheader})
  }

  getLeadScanData(lead_id,scan_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-lead-scan-details/'+lead_id+'/'+scan_id,{headers:webheader})
  }

  getscanprouser(){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-scan-pro-user',{headers:webheader})
  }

  getDentalAppointmentDataForDashboard(){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-dental-appointment-data-dashboard',{headers:webheader})
  }

  getTotalDentalAppointmentDataForDashboard(){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-total-dental-appointment-data-dashboard',{headers:webheader})
  }

  addScanBook(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'save-scan-book',data,{headers:webheader})
  }

  updateScanBook(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-scan-book',data,{headers:webheader})
  }
  
  loadScanBooks(pageno,limit,qstring){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'scan-book-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addPaymentScanBook(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-scan-book-payment',data,{headers:webheader})
  }

  updatePaymentScanBook(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-scan-book-payment',data,{headers:webheader})
  }

  uploadScanFile(scan_id,lead_id,formData)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'upload-scan-docs/'+scan_id+'/'+lead_id,formData,{headers:webheader,})
  }

  updateScanStatus(scan_id,status){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'update-scan-book-status/'+scan_id+'/'+status,{headers:webheader})
  }

  uploadPlanFile(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      formData.append(key, data[key]);
    }

    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'upload-plan-docs',formData,{headers:webheader,})
  }

  planShareWithPatient(scan_id,plan_share_type) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'plan-share-with-patient/'+scan_id+'/'+plan_share_type,{headers:webheader})
  }

  shareGoogleLinks(scan_id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'share-google-link/'+scan_id,{headers:webheader})
  }

  sendPaymentOTP(otp_mobile, otp_receive_amount, otp_payment_mode, lead_id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'share-payment-otp-to-patient/'+otp_mobile+'/'+otp_receive_amount+'/'+otp_payment_mode+'/'+lead_id,{headers:webheader})
  }

  verifyOtp(otp_mobile, otp_receive_amount, otp_payment_mode, otp_payment_otp, lead_id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'verify-otp-of-patient/'+otp_mobile+'/'+otp_receive_amount+'/'+otp_payment_mode+'/'+otp_payment_otp+'/'+lead_id, {headers:webheader})
  }


  deleteScanFiles(fileId)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.delete(apiUrl+'delete-booked-scan-file/'+fileId,{headers:webheader})
  }

  fetchReceivedAmount(lead_id, scan_id)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'fetch-received-amount/'+lead_id+'/'+scan_id,{headers:webheader})
  }

  fetchReceivedAmountForAccounts(lead_id, scan_id)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'fetch-received-amount-for-accounts/'+lead_id+'/'+scan_id,{headers:webheader})
  }

  amountReceivedDeleted(scan_payment_id) {
    let webheader = this.sharedapi.getHeaders();
    return this.http.delete(apiUrl+'delete-scan-payment/'+scan_payment_id,{headers:webheader})
  }

  updateScanBookForProductionStatus(data){

    var formData: any = new FormData();
  	for (const key in data) 
    { 
      /* if(data[key] != null && (key=='aligner_dispatched_date' || key=='aligner_delivery_date' || key=='approval_received_date'))
      {
        formData.append(key, data[key].getFullYear()+'-'+(data[key].getMonth()+1)+'-'+data[key].getDate());
      }
      else  */if(data[key] != null)
      {
        formData.append(key, data[key]);
      }
      else
      {
        formData.append(key, '');
      }
    }

    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-scan-book-for-product-status',formData,{headers:webheader})
  }

  getFullScanBookHistory(lead_id, scan_book_id)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-full-scanbook-history/'+lead_id+'/'+scan_book_id,{headers:webheader})
  }

  getCityWisePerformanceFieldSalesPaymentSummary(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-city-wise-performance-field-sales-payment-summary?'+qstring,{headers:webheader})
  }

  getScanProWisePerformanceFieldSalesPaymentSummary(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-scanpro-wise-performance-field-sales-payment-summary?'+qstring,{headers:webheader})
  }

  getBDWisePerformanceFieldSalesPaymentSummary(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-bd-wise-performance-field-sales-payment-summary?'+qstring,{headers:webheader})
  }

  getClinicWisePerformanceFieldSales(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-clinic-wise-performance-field-sales?'+qstring,{headers:webheader})
  }

  getBucketWisePendingPayment(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-bucket-wise-pending-payment?'+qstring,{headers:webheader})
  }

  getDispositionAnalysisData(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-disposition-analysis-data?'+qstring,{headers:webheader})
  }

  prePlanCustomerLists(qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'preplan-customer-lists?'+qstring,{headers:webheader})
  }

  planSentLists(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'plan-sent-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  scanReportLists(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'scan-report-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  deliveryReportLists(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delivery-report-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  getDentalCommonData()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-dental-common-data',{headers:webheader})
  }

  updateSingleData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.put(apiUrl+'save-dental-single-data',data,{headers:webheader})
  }
  
  getDentalSpocRoleData()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-dental-spoc-role',{headers:webheader})
  }

  assigneDentalSpok(userId:number, scanbook_id:number)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-scan-book-assignee/'+scanbook_id, {userId:userId}, {headers:webheader});
  }

  getDentalSpokRemarkStatus(parent_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-dental-spok-remark-status/'+parent_id,{headers:webheader})
  }

  addDentalSpokRemarkData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-dental-spok-remark-data',data,{headers:webheader})
  }

  addAccountsRemarkData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-accounuts-remark-data', data, {headers:webheader})
  }


  getSingleSpokRemarkData(data)
  {
      let scan_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-single-dental-spok-remark-data/'+scan_id,{headers:webheader})
  }
  getScanbookData(data)
  {
      let scan_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-scan-details/'+scan_id,{headers:webheader})
  }
  updateScanbookDataForPro(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-scanbook-data',data,{headers:webheader})
  }
  getHospitalAddress(hospital_id)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-hospital-address/'+hospital_id,{headers:webheader})
  }

  getOrthodntistUser(status=1)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-orthodontist-user/'+status,{headers:webheader})
  }

  loadOrthodontistScanBooks(pageno,limit,qstring){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'orthodontist-scan-book-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  getUpdateOdsData(scan_id, qString)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-update-ods-scan-data/'+scan_id+'?'+qString,{headers:webheader})
  }

  getUpdateOdsDataForLab(scan_id, qString)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-update-ods-scan-data-for-lab/'+scan_id+'?'+qString,{headers:webheader})
  }

  uploadPlanData(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'upload-plan-data',formData,{headers:webheader})
  }


  deleteplanFiles(fileId)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.delete(apiUrl+'delete-plan-upload-file/'+fileId,{headers:webheader})
  }


  getScanBookCaseHistoryData(scanId)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-scan-book-case-history-data/'+scanId,{headers:webheader})
  }

  saveScanBookCaseHistoryData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-scanBook-case-history-data',data,{headers:webheader})
  }

  download_plan_pdf(send_download_type, scanId, labId, scan_type)
  {
    if(send_download_type == 1)
    {
      window.open(GlobalConstants.openApiURL+'download-pdf-glamyo-health/'+scanId+'/'+labId+'/'+scan_type);
    }
    else if(send_download_type == 3)
    {
      window.open(GlobalConstants.openApiURL+'download-pdf-trust-align/'+scanId+'/'+labId+'/'+scan_type);
    }
  }
  
  sendPdfPlanEmail(send_download_type, scanId, labId, scan_type)
  {
    let webheader = this.sharedapi.getHeaders();
    if(send_download_type == 1)
    {
      return this.http.get(apiUrl+'send-glamyo-pdf-plan-email/'+scanId+'/'+labId+'/'+scan_type,{headers:webheader});
    }
    else if(send_download_type == 3)
    {
      return this.http.get(apiUrl+'send-trust-align-pdf-plan-email/'+scanId+'/'+labId+'/'+scan_type,{headers:webheader});
    }
  }

  getPaymentReportData(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-scan-payment-report/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }
  download_payment_receipt(scanId)
  {
    window.open(GlobalConstants.openApiURL+'download-payment-receipt/'+scanId);
  }

  sendPaymentReceipt(scanId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'send-payment-receipt-email/'+scanId,{headers:webheader});
  }

  getAppointmentTypeOfLab(lab_id, scanId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-appointment-type-of-lab/'+lab_id+'/'+scanId,{headers:webheader})
  }

  getScantypeOfLab(lab_id, appt_type_id, scanId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-plan-type-of-lab/'+lab_id+'/'+appt_type_id+'/'+scanId,{headers:webheader})
  }

  getLabScabookDetails(lab_id,scanId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-lab-scan-book-details/'+lab_id+'/'+scanId,{headers:webheader})
  }

}

